import React, { Component } from 'react';


class WerkervaringContent extends Component {
    render() {
        return (
                <div className="action" id="uitleg">
                    <h2>Toelichting invoeren werkervaring</h2>
                    <h3>Stap 1: invoeren gegevens referenten</h3>

                    <p>De eerste stap bij het invoeren van uw werkervaring is het invoeren van
                    de gegevens van uw referent. De referent is in principe uw (voormalig)
                    functioneel leidinggevende of opdrachtgever. Hij/zij is in staat uw
                    werkniveau en de kwaliteit van uw werk te beoordelen. In het geval deze
                    ontbreekt kunt u een collega met vergelijkbaar leidinggevend
functieniveau als referent opgeven of een (voormalig) opdrachtgever.</p>


                    <h3>Stap 2: invoeren gegevens werkervaring</h3>
                    <p>U dient uw werkervaring op de twee manieren in te voeren:
</p><h4>1. werkervaring per project</h4>
                    <p>U kunt de toelichting per project toevoegen of een document maken, waarin u al uw projecten nader toelicht.
Voor een inhoudelijk beeld van uw werkervaring dient u minimaal 6 projecten toe te lichten. Dit kunnen de hoogtepunten uit uw carrière zijn. Belangrijke informatie is uw rol/verantwoordelijkheid in het project als constructeur en informatie over de omvang van het project, bijvoorbeeld m2, tonnen, projectbudget. U kunt het project toelichten met bijvoorbeeld tekeningen, berekeningen en foto's. (het pdf-bestand mag niet groter dan 2 Mb zijn). Per project kunt u 1 bestand uploaden.</p>

                    <h4>2. geclusterde werkervaring</h4>
                    <p>Naast de projectinhoudelijke werkervaring dient u uw werkervaring
                      te clusteren per referent en per werkniveau. Per referent dient u in
                      een bijlage een overzicht te geven van de projecten, projectgrootte,
                      bestede uren, uw rol en werkzaamheden. Let hierbij op dat u de bestede
                      uren in de eerder genoemde projecten niet opneemt in de clustering.
                  
  </p>
                    <h4>Richtlijnen voor invoer van uw gegevens:</h4>
                    <ul>
                        <li>de registerconstructeur dient minimaal 6 ervaringseenheden te behalen</li>
                        <li>de registerontwerper dient minimaal 5 ervaringseenheden op O-niveau te behalen</li>
                        <li>een registertoetser a dient minimaal 6 ervaringseenheden te behalden, waarvan 3 als toetser t.b.v. klasse 1-2a</li>
                        <li>een registertoetser b dient minimaal 10 ervaringseenheden te behalen, waarvan 5 als toetser t.b.v. klasse 2b-3.</li>
                        <li>1 jaar = 1600 gewerkte uren, 1 maand is 133 uur</li>
                        <li>opgave van minimaal 6 projecten plus opgave van geclusterde werkervaring</li>
                        <li>projectinformatie en werkzaamheden dienen in de daartoe bestemde velden ingevoerd te worden. De bijlagen bevatten ondersteunende informatie.</li>
                    </ul>

                    <p>
                        <strong>Let op:</strong> zolang de gegevens niet geaccordeerd zijn
                        door de referent kunt u de ingevoerde gegevens wijzigen. Klik
                        hiervoor op 'wijzigen' in uw overzicht werkervaring. Wijzigingen
                        in gefiatteerde werkervaringen kunt u alleen aanbrengen door de
                        regel te verwijderen en opnieuw in te voeren.  De referent
                        ontvangt pas de uitnodiging voor akkoord geven als u op de button
                        stuur referenten controle e-mail heeft gedrukt.
  </p>


                    <table>
                        <caption>
                            Registerconstructeur
    </caption>
                        <thead>
                            <tr><th> Werkzaamheden</th>
                                <th>Niveau</th><th>eenheid</th><th>n</th><th>γ </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>Tekenaar maakt onder leiding constructieve tekeningen</td><td>C1</td>
                                <td>jaren</td><td>&nbsp;</td><td>0 </td></tr>
                            <tr><td>Constructeur ontwerpt en berekent details en/of bouwdelen onder supervisie</td><td>C2</td>
                                <td>jaren</td><td>&nbsp;</td><td>0,4  </td></tr>
                            <tr><td>Constructeur ontwerpt en berekent zelfstandig details en/of bouwdelen, berekent onder supervisie hoofddraagconstructies</td><td>C3</td>
                                <td>jaren</td><td>&nbsp;</td><td>0,8  </td></tr>
                            <tr><td>Constructeur ontwerpt/berekent zelfstandig constructies</td><td>C4</td>
                                <td>jaren</td><td>&nbsp;</td><td>1,0  </td></tr>
                            <tr><td>Constructeur / projectleider</td><td>C5</td>
                                <td>jaren</td><td>&nbsp;</td><td>1,2  </td></tr>
                        </tbody>
                    </table>

                    <table>
                        <caption>
                            Registerontwerper
    </caption>
                        <thead>
                            <tr>
                                <th>Functieomschrijving</th>
                                <th>Niveau</th>
                                <th>Eenheid</th>
                                <th>n</th>
                                <th>factor γ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Specialist constructeur</td>
                                <td>O1 </td>
                                <td>jaren </td>
                                <td></td>
                                <td>0,8 </td>
                            </tr>
                            <tr>
                                <td>Constructief adviseur, raadgevend adviseur</td>
                                <td>O2 </td>
                                <td>jaren </td>
                                <td></td>
                                <td>1,2 </td>
                            </tr>
                        </tbody>
                    </table>

                    <table>
                        <caption>
                            Registertoetser
    </caption>
                        <thead>
                            <tr>
                                <th>Niveau</th>
                                <th>Werkzaamheden voor</th>
                                <th>Eenheid</th>
                                <th>n</th>
                                <th>Y</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>RTa</td>
                                <td>Gevolgklasse CC1</td>
                                <td>jaren</td>
                                <td></td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td>RTa</td>
                                <td>Gevolgklasse CC2a</td>
                                <td>jaren</td>
                                <td></td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td>RTb</td>
                                <td>Gevolgklasse CC2b</td>
                                <td>jaren</td>
                                <td></td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td>RTb</td>
                                <td>Gevolgklasse CC3</td>
                                <td>jaren</td>
                                <td></td>
                                <td>1</td>
                            </tr>
                        </tbody>
                    </table>

                    <p>
                        <a href="/rapport/voorbeeld">Klik hier voor een voorbeeld voor invoer van werkervaring.</a>
                    </p>

                    <h3>Stap 3:</h3>
                    <p>Nadat u uw gegevens heeft ingevoerd en bestanden ge-upload dient u
                      uw referent om beoordeling van uw werkervaring te vragen met de knop
                      Stuur referenten controle emailbericht. Het systeem genereert een
                      emailbericht. Uw referent ontvangt in zijn mailbericht een link,
                      waarmee hij toegang krijgt tot uw gegevens. Uw referent dient uw
                      gegevens te controleren en akkoord te geven. Bij geen akkoord ontvangt
                      u een mailbericht dat de werkervaring niet akkoord is bevonden. De
    ervaringsregel wordt automatisch verwijderd uit uw overzicht.<br />
                            Als uw referent niet binnen twee weken reageert, ontvangt hij na
                                twee weken een herinnering per mail.
                        </p>
                        <p>
                            Op basis van al uw gegevens wordt een rapportage samengesteld. Deze
    kunt u opvragen onder Rapport.</p>  
            </div>
            
        );
    }
}

export default WerkervaringContent;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Werkervaring/WerkervaringContent.js